import { preview } from '@/components/form/preview'

import { useTexts } from './hooks/useTexts'

interface Props {
  additionalDrivingTimeSec: number
  malus: number
  mixed?: boolean
}

export function ViewDetails(props: Props) {
  const { additionalDrivingTimeSec, malus, mixed } = props

  const texts = useTexts()

  if (mixed) {
    return <preview.MultipleValues />
  }

  return (
    <>
      {malus > 0 && (
        <preview.Field label={texts.type} testId="road-segment-view-blocked">
          {texts.singleMalus}
        </preview.Field>
      )}

      {additionalDrivingTimeSec > 0 && (
        <preview.Field label={texts.type} testId="road-segment-view-additionalTime">
          {`${texts.additionalTime}: `}
          <preview.DurationValue>{additionalDrivingTimeSec}</preview.DurationValue>
        </preview.Field>
      )}

      {additionalDrivingTimeSec === 0 && malus === 0 && (
        <preview.Field label={texts.type} testId="road-segment-view-disabled">
          {texts.disabled}
        </preview.Field>
      )}
    </>
  )
}
